import React, { useMemo } from "react";
import KeyedDropdown from "../../Dropdown/KeyedDropdown";
import { useSpaceQuery } from "../../../Helpers/IOClient";
import dayjs from "dayjs";
import { AccountProfileImg } from "../../Img/Img";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCodeCommit } from "@fortawesome/pro-light-svg-icons";

const EMPTY_COLLECTION = { Id: null, Name: "N/A" };

export const AlgDevCommitValueComponent = ({
  item,
  size,
  className,
  addLink,
}) => {
  if (!item || item.Id === null) {
    return (
      <span className="fs-14 fw-regular" style={{ color: "#7C98B6" }}>
        &nbsp;
      </span>
    );
  }
  return (
    <div className="align-items-center d-flex of-hidden w-100">
      <AccountProfileImg
        circular
        size={size ? size : "mds"}
        account={{
          Image: item.Avatar,
          Name: item.Email ? item.Email.split("@")[0].replace(".", " ") : "",
        }}
      />
      <div className="align-items-center d-flex flex-1 flex-md-shrink-1 justify-content-between ml-2 of-hidden w-100 w-fit">
        <div className="flex-1 text-truncate pr-2">
          <div
            className={className ? className : "text-truncate fs-14 fw-regular"}
          >
            {item.Comment}
          </div>
          <div className="dropdown-item-subtext-dif text-truncate">
            {item.Email}
            {" | "}
            {item.Date ? dayjs(item.Date).format("DD-MM-YYYY HH:mm") : ""}
          </div>
        </div>
        {addLink ? (
          <a href={addLink} target="_blank" rel="noreferrer">
            <div class="d-flex flex-0-0-auto align-items-center justify-content-end status-color-inactive pr-2">
              <div class="d-flex py-1 px-2 fs-12 align-items-center status-list-template text-black">
                <FontAwesomeIcon
                  className="text-black"
                  icon={faCodeCommit}
                  size="lg"
                  rotation={90}
                />
                <span className="ml-1 text-black">
                  {typeof item.Id === "string" ? item.Id.slice(0, 8) : ""}
                </span>
              </div>
            </div>
          </a>
        ) : (
          <div class="d-flex flex-0-0-auto align-items-center justify-content-end status-color-inactive pr-2">
            <div class="d-flex py-1 px-2 fs-12 align-items-center status-list-template text-black">
              <FontAwesomeIcon
                className="text-black"
                icon={faCodeCommit}
                size="lg"
                rotation={90}
              />
              <span className="ml-1 text-black">
                {typeof item.Id === "string" ? item.Id.slice(0, 8) : ""}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const AlgDevCommitDropdown = ({
  collection,
  project,
  repository,
  ...props
}) => {
  const resolvedUrl = useMemo(() => {
    if (collection && project && repository) {
      return `Integrations/Devops/Query/${collection}/${project}/${repository}/Commits`;
    } else return null;
  }, [collection, project, repository]);

  const { data, loading } = useSpaceQuery(resolvedUrl, null, {
    cache: false,
  });

  const options = useMemo(() => {
    const items = !loading && Array.isArray(data) ? data : [];
    if (items.length > 0) return [EMPTY_COLLECTION, ...items];
    else return [EMPTY_COLLECTION];
  }, [data, loading]);

  return (
    <KeyedDropdown
      options={options}
      getKey={(e) => (e.Id === null ? "empty" : e.Id)}
      valueComponent={AlgDevCommitValueComponent}
      closeOnSelect
      {...props}
      disabled={loading || (Array.isArray(data) && data.length === 0)}
      className={"of-hidden"}
      dropdownClassname={"of-hidden"}
    />
  );
};

export default AlgDevCommitDropdown;
